import React, { useState, useEffect } from 'react';

type Props = {
  children: React.ReactElement;
  waitBeforeShow?: number;
};

const Delayed = ({ children, waitBeforeShow = 500 }: Props) => {
  const [isShown, setIsShown] = useState(false);

  useEffect(() => {
    const timeoutId = setTimeout(() => {
      setIsShown(true);
    }, waitBeforeShow);

    // useEffect cleanup function
    return () => {
        clearTimeout(timeoutId);
      };

  }, [waitBeforeShow]);

  return isShown ? children : null;
};

export default Delayed;